export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/ws.worker.b2bf7088c43930e4e2d1.worker.js");
}
